<template>
  <div class="pdf-container">
    <div ref="pdfWrapper" class="pdf-wrapper"></div>
  </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf';
import workerPath from 'pdfjs-dist/legacy/build/pdf.worker.entry';

pdfjsLib.GlobalWorkerOptions.workerSrc = workerPath;

export default {
  name: 'PdfViewer',
  props: {
    src: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      pdfDoc: null
    };
  },
  mounted() {
    this.loadPdf(this.src);
  },
  methods: {
    async loadPdf(url) {
      try {
        const loadingTask = pdfjsLib.getDocument(url);
        this.pdfDoc = await loadingTask.promise;

        const wrapper = this.$refs.pdfWrapper;
        wrapper.innerHTML = ''; // 清空旧的

        for (let i = 1; i <= this.pdfDoc.numPages; i++) {
          const page = await this.pdfDoc.getPage(i);
          const viewport = page.getViewport({ scale: 1.5 });

          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          const renderContext = {
            canvasContext: context,
            viewport
          };

          await page.render(renderContext).promise;
          wrapper.appendChild(canvas);
        }
      } catch (err) {
        console.error('error：', err);
      }
    }
  }
};

</script>

<style >
.pdf-container {
  height: 100vh;
  overflow-y: auto;
  padding: 10px;
  background: #f9f9f9;
}

.pdf-wrapper canvas {
  display: block;
  /* margin-bottom: 10px; */
  width: 100%;
  height: auto;
  background: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

</style>
